export enum FilterChipVariant {
    Default = "default",
    Country = "country",
    State = "state",
    Icon = "icon",
    Website = "website",
}
